
  // export const environment = {
  //   baseUrl: "http://103.42.198.95:5010/",
  //   encryptionKey: '33281600a838a748e367002e2991a2ee',
  //   production: true
  // };
  export const environment = {
    baseUrl: 'https://test.shajipaints.com/dev/',
    encryptionKey: 'be8fa8e4242a82e8',
    production: false,
  };
  